import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import Button from './Button';
import ModalHeader from './ModalHeader.js';
import Icon from './Icon';
import i18n from '../../src/i18n/translate';
import { formatClassName } from '../Util';

export default class ConfirmationModal extends React.Component {

  static propTypes = {
    branded: PropTypes.bool,
    confirmButtonClass: PropTypes.string,
    confirmButtonText: PropTypes.string,
    cancelButtonClass: PropTypes.string,
    cancelButtonText: PropTypes.string,
    canClickOff: PropTypes.bool,
    confirmOnly: PropTypes.bool,
    confirmButtonDisabled: PropTypes.bool,
    confirmButtonLoading: PropTypes.bool,
    container: PropTypes.node,
    children: PropTypes.node,
    data: PropTypes.object,
    dialogClass: PropTypes.string,
    modalClass: PropTypes.string,
    modalSize: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    id: PropTypes.string,
    show: PropTypes.bool,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ])
  };

  static defaultProps = {
    id: 'confirmation-modal',
    modalClass: '',
    modalSize: 'small',
    dialogClass: '',
    confirmButtonDisabled: false,
    confirmButtonLoading: false
  };

  constructor(props) {
    super(props);
    this.closeWithConfirm = this.closeWithConfirm.bind(this);
  }

  closeWithConfirm(e) {
    this.props.onConfirm(this.props.data, e);
  }

  renderFooter() {
    const {
      branded = false,
      cancelButtonClass,
      cancelButtonText = i18n.t("Cancel"),
      confirmButtonClass,
      confirmButtonDisabled,
      confirmButtonLoading,
      confirmButtonText = i18n.t("OK"),
      confirmOnly,
      id,
      onCancel
    } = this.props;
    return (
      <Modal.Footer>
        {!confirmOnly &&
          <Button
            autoFocus={true}
            branded={branded}
            className={cancelButtonClass}
            data={{ action: 'cancel' }}
            id={`${id}-cancel-button`}
            label={cancelButtonText}
            onClick={onCancel}
            ref={button => { this.cancelButton = button }}
            style="secondary"
          />
        }
        <Button
          autoFocus={confirmOnly}
          branded={branded}
          className={confirmButtonClass}
          data={{ action: 'confirm' }}
          disabled={confirmButtonDisabled}
          id={`${id}-confirm-button`}
          onClick={this.closeWithConfirm}
          style="primary"
        >
          {confirmButtonLoading && <Icon spin={true} iconType="spinner" />}
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    );
  }

  getModalClasses = () => {
    const { modalClass, modalSize } = this.props;
    return formatClassName([
      'confirm-modal',
      `modal-size-${modalSize}`,
      `${modalClass}`
    ])
  }

  render() {

    const {
      canClickOff,
      children,
      container,
      data,
      dialogClass,
      id,
      onCancel,
      show,
      title
    } = this.props;
    let modalClassName = this.getModalClasses();

    return (
      <Modal
        aria-labelledby={`${id}-title`}
        backdrop={canClickOff ? true : 'static'}
        backdropClassName="confirm-modal-backdrop"
        className={modalClassName}
        container={container}
        dialogClassName={`confirm-dialog ${dialogClass}`}
        id={id}
        keyboard={canClickOff}
        onEntered={this.onEntered}
        onHide={onCancel}
        show={(show === undefined || show === null) ? !!data : show}
      >
        <ModalHeader onCancel={onCancel} canClickOff={canClickOff} title={title} titleId={`${id}-title`} />
        <Modal.Body>
          {children}
        </Modal.Body>
        {this.renderFooter()}
      </Modal>
    );
  }
}
